// extracted by mini-css-extract-plugin
export default {"slide":"AddSceneSidebar_slide__QC4u3","attachments":"AddSceneSidebar_attachments__owXyJ","files":"AddSceneSidebar_files__DRc23"};